import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

const dialogTitleStyles = makeStyles<ISpcTheme>(() => ({
  title: {
    marginBottom: '0.4rem',
  },
}));

export default dialogTitleStyles;
